import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FiCheckCircle, FiPackage } from 'react-icons/fi';
import API from '../api/axios';
import { formatPrice } from '../utils/helpers';

const OrderSuccessPage = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (id) {
      API.get(`/orders/${id}`).then(({ data }) => setOrder(data)).catch(() => {});
    }
  }, [id]);

  return (
    <div className="container-custom py-16 text-center max-w-2xl mx-auto">
      <div className="card p-10">
        <FiCheckCircle size={72} className="mx-auto text-green-500 mb-4" />
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Order Placed Successfully!</h1>
        <p className="text-gray-500 mb-6">Thank you for your order. We'll contact you soon to confirm.</p>

        {order && (
          <div className="bg-gray-50 rounded-xl p-5 text-left mb-6">
            <div className="flex justify-between items-center mb-3">
              <span className="font-semibold text-gray-700">Order Number</span>
              <span className="font-bold text-primary-600">{order.orderNumber}</span>
            </div>
            <div className="flex justify-between items-center mb-3">
              <span className="text-gray-600 text-sm">Status</span>
              <span className="badge bg-yellow-100 text-yellow-800 capitalize">{order.orderStatus}</span>
            </div>
            <div className="flex justify-between items-center mb-3">
              <span className="text-gray-600 text-sm">Payment</span>
              <span className="text-sm font-medium capitalize">{order.paymentMethod === 'cod' ? 'Cash on Delivery' : 'Bank Transfer'}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600 text-sm">Total Amount</span>
              <span className="font-bold text-primary-600 text-lg">{formatPrice(order.total)}</span>
            </div>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/account/orders" className="btn-primary flex items-center justify-center gap-2">
            <FiPackage size={16} /> Track My Order
          </Link>
          <Link to="/shop" className="btn-secondary flex items-center justify-center gap-2">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
